import { createSlice, createSelector } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap, map, catchError } from "rxjs/operators";
const CURRENCY_VARIABLES_FEATURE_KEY = "currencyVariables";
var CurrencyVariableFields = /* @__PURE__ */ ((CurrencyVariableFields2) => {
  CurrencyVariableFields2["id"] = "id";
  CurrencyVariableFields2["isActive"] = "isActive";
  CurrencyVariableFields2["amountInBaseCurrency"] = "amountInBaseCurrency";
  CurrencyVariableFields2["description"] = "description";
  CurrencyVariableFields2["values"] = "values";
  CurrencyVariableFields2["frontendIdentifier"] = "frontendIdentifier";
  return CurrencyVariableFields2;
})(CurrencyVariableFields || {});
const initialCurrencyVariablesState = {
  entities: [],
  error: null,
  loaded: false
};
const currencyVariablesSlice = createSlice({
  name: CURRENCY_VARIABLES_FEATURE_KEY,
  initialState: initialCurrencyVariablesState,
  reducers: {
    getCurrencyVariablesStart: (state) => {
      state.loaded = false;
    },
    getCurrencyVariablesSuccess: (state, action) => {
      state.loaded = true;
      state.entities = action.payload;
    },
    getCurrencyVariablesFailure: (state, action) => {
      state.loaded = true;
      state.error = action.payload;
    }
  }
});
const currencyVariablesReducer = currencyVariablesSlice.reducer;
const {
  getCurrencyVariablesStart,
  getCurrencyVariablesSuccess,
  getCurrencyVariablesFailure
} = currencyVariablesSlice.actions;
const getCurrencyVariablesState = (rootState) => rootState[CURRENCY_VARIABLES_FEATURE_KEY];
const selectCurrencyVariablesEntities = createSelector(
  getCurrencyVariablesState,
  (s) => s.entities
);
const selectCurrencyVariablesLoaded = createSelector(
  getCurrencyVariablesState,
  (s) => s.loaded
);
const fetchCurrencyVariables = () => ({
  type: getCurrencyVariablesStart.type
});
const currencyVariablesEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getCurrencyVariablesStart.type),
  switchMap(() => {
    return Api.geoClient.getCurrencyVariables().pipe(
      map((results) => {
        return getCurrencyVariablesSuccess(results.items);
      }),
      catchError((err) => of(getCurrencyVariablesFailure(err)))
    );
  })
);
export {
  CURRENCY_VARIABLES_FEATURE_KEY,
  CurrencyVariableFields,
  currencyVariablesEpic,
  currencyVariablesReducer,
  currencyVariablesSlice,
  fetchCurrencyVariables,
  getCurrencyVariablesFailure,
  getCurrencyVariablesStart,
  getCurrencyVariablesState,
  getCurrencyVariablesSuccess,
  initialCurrencyVariablesState,
  selectCurrencyVariablesEntities,
  selectCurrencyVariablesLoaded
};
